module.exports = __webpack_public_path__ + "690fe6b400136419ce4d415d77ad03d6.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1087
// module chunks = 0